import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-regect_back",
  "use": "icon-regect_back-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-regect_back\">\n<circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#FAAD14\" />\n<path d=\"M10 5L5 6.66667L6.66667 11.6667\" stroke=\"#FAAD14\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M4.9974 6.66602C11.2474 8.74935 12.4974 9.99935 14.1641 14.166\" stroke=\"#FAAD14\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol